export default "__VITE_ASSET__c1d3eab2__"